module.exports = __webpack_public_path__ + "img/top01.e2f0727f.gif";